module.exports = __webpack_public_path__ + "static/speed-e641c7135d7fc86478582e7851ee211d.png";